import { useState } from "react";
import { AskAIGameView } from "../views/askAIGameView.jsx";
import { useParams } from "react-router-dom";
import { updateProgressReduxCB } from "../util/helpersFunction.js";
import locationTask from "../data/locationTask.json";
import ChatApi from "../util/chatApi.js";

function AskAIGame() {
  const { id, mode } = useParams();
  const location = locationTask[id];
  const title = location?.title;
  const [answer, setAnswer] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const quest = "speechBubble";
  const [currentStep, setCurrentStep] = useState(3);
  const [inputValue, setInputValue] = useState("");
  const imageKey = `drawing_${id}`;

  const [loading, setLoading] = useState(false);

  if (!location) {
    return <div>Location not found</div>;
  }

  const handleSubmitACB = async () => {
    if (!inputValue.trim()) return;
     setCurrentStep(4);
    setSubmitted(true);
    setLoading(true);

    try {
      // Simulate delay
      await new Promise((resolve) => setTimeout(resolve, 1500));

      const response = await ChatApi.getChatResponse(
        inputValue,
        `Reply playfully and briefly to the user's question about "${title}", which is a location.`
      );
      setAnswer(response);
      
    } catch (error) {
      console.error("ChatGPT feedback error:", error);
    } finally {
      setLoading(false);
     
    }
    const status = "success";
      updateProgressReduxCB(id, mode, status, quest);
  };

  function handleGoToModeInfoACB() {
    window.location.hash = `#/questComplete/${id}/${mode}/${quest}`;
  }
  function handleInputChangeACB(e) {
    setInputValue(e.target.value);
  }
  return (
    <AskAIGameView
      mode={mode}
      title={title}
      currentStep={currentStep}
      inputValue={inputValue}
      onInputChange={handleInputChangeACB}
      submitted={submitted}
      onSubmit={handleSubmitACB}
      answer={answer}
      loading={loading}
      imageKey={imageKey}
      onComplete={handleGoToModeInfoACB}
    />
  );
}

export { AskAIGame };
